export default {
  title: 'Bankgegevens',
  sections: {
    personal_info: 'Persoonlijke gegevens',
    address: 'Adres',
  },
  labels: {
    account_number: 'Rekeningnummer',
    routing_number: 'Routeringsnummer',
    email: 'E-mail',
    full_name: 'Volledige naam',
    street: 'Straatadres',
    zip_code: 'Postcode',
    city: 'Stad',
  },
  tooltip: '{{field}} is gekopieerd naar klembord!',
};
